import { Dialog,
    // DialogActions,
     DialogContent,
      DialogTitle,
      //  IconButton,
        // Typography 
      } from '@material-ui/core';
        // import CloseIcon from '@material-ui/icons/Close';

import React from 'react'
import { colors } from '../constants/colors';
// import { ApproveModal } from '../screens/admin/PackingType/ViewCan';
// import Button from './Button';
  // eslint-disable-next-line
const style = {
   position: "absolute",
   top: "50%",
   left: "50%",
   transform: "translate(-50%, -50%)",
   width: 900,
   bgcolor: "background.paper",
   boxShadow: 24,
   p: 4
}

function CustomModal(props) {

const { openModal, body, title } = props;

 return (
   <div>
   <Dialog
    maxWidth="xl"
  
       aria-labelledby="customized-dialog-title"
       open={openModal}
     >
       <DialogTitle sx={{ m: 0, p:2}} 
       style={{
           // backgroundColor: colors.orange,
           color: colors.orange,
           fontSize: "1rem",
       }}>
        {title}
         {/* <IconButton 
            aria-label="close"
            onClick={closeModal}
            sx={{
               position: "absolute",
               right: 8,
               top: 8,
               color: "#fff",
            }}
            >
           <CloseIcon />
         </IconButton> */}
       </DialogTitle>
       <DialogContent dividers>
          {body}
       </DialogContent>
       {/* <DialogActions>
         <Button label="Submit" onClick={closeModal} />
         <Button label="Cancel" onClick={closeModal} />
       </DialogActions> */}
     </Dialog>
   </div>
 )
}

export default CustomModal